const classDetail = {
  path: 'classDetail',
  props: true,
  component: resolve => require(['../../../../../components/pages/student_user/homeClass/classDetail'], resolve)
}
export default classDetail



// WEBPACK FOOTER //
// ./src/router/pages/student_user/homeClass/classDetail/index.js